<script setup lang="ts">
import { EcommerceProductReview } from '@zyro-inc/site-modules/types';
import ReviewStars from '@zyro-inc/site-modules/components/blocks/ecommerce/-partials/ReviewStars.vue';
import { formatDate } from '@zyro-inc/site-modules/utils/ecommerce/date';

defineProps<{
	review: EcommerceProductReview,
	translations: Record<string, string>,
}>();

</script>

<template>
	<div
		class="product-review"
		data-qa="product-review"
	>
		<div class="product-review__header">
			<ReviewStars
				class="product-review__rating"
				:rating="review.rating"
			/>
			<p class="product-review__date">
				{{ formatDate(review.created_at) }}
			</p>
		</div>
		<div class="product-review__content">
			<p class="product-review__comment">
				{{ review.comment }}
			</p>
			<p class="product-review__author">
				{{ review.reviewer_name || translations.anonymous || 'Anonymous' }}
			</p>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.product-review {
	margin-bottom: 24px;
	padding: 28px 24px;
	border-radius: 4px;
	border: 1px solid $color-gray-border;

	&__header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 32px;
	}

	&__rating {
		margin-right: 16px;
	}

	&__author {
		font-weight: 500;
	}

	&__comment {
		margin-bottom: 16px;
	}
}
</style>
